module.exports = __webpack_public_path__ + "static/assets/267cc6ea26d74bb7d8c585161f43c311.svg";